import { render, staticRenderFns } from "./dynamicList.vue?vue&type=template&id=6fe9879d&scoped=true"
import script from "./dynamicList.vue?vue&type=script&lang=js"
export * from "./dynamicList.vue?vue&type=script&lang=js"
import style0 from "./dynamicList.vue?vue&type=style&index=0&id=6fe9879d&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe9879d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe9879d')) {
      api.createRecord('6fe9879d', component.options)
    } else {
      api.reload('6fe9879d', component.options)
    }
    module.hot.accept("./dynamicList.vue?vue&type=template&id=6fe9879d&scoped=true", function () {
      api.rerender('6fe9879d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/dynamicList.vue"
export default component.exports